import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import { ThemeProvider as StylesThemeProvider } from "@mui/styles";
import ScrollToTop from "components/ScrollToTop";
import { Profiler } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import theme from "styles/theme";
import App from "./App";
import "./index.css";
import "./index.scss";

const root = ReactDOM.createRoot(document.getElementById("root")!);

function onRender(
  id: string,
  phase: string,
  actualDuration: number,
  baseDuration: number,
  startTime: number,
  commitTime: number
) {
  // console.table({
  //   id,
  //   phase,
  //   actualDuration,
  //   baseDuration,
  //   startTime,
  //   commitTime,
  // });
}

root.render(
  <BrowserRouter>
    <ScrollToTop />
    <Profiler id="app" onRender={onRender}>
      <MuiThemeProvider theme={theme}>
        <StylesThemeProvider theme={theme}>
          <App />
        </StylesThemeProvider>
      </MuiThemeProvider>
    </Profiler>
  </BrowserRouter>
);
